import React from "react";
import {
  Box,
  Container,
  Typography,
  IconButton,
  Link,
  Divider,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import { useNavigate } from "react-router-dom";
import getIdentity from "../../services/getIdentity";
import packageInfo from "../../../package.json";

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [identifier, setIdentifier] = React.useState("");

  React.useEffect(() => {
    const fetchIdentifier = async () => {
      const id = await getIdentity();
      setIdentifier(id);
    };
    fetchIdentifier();
  }, []);

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "background.paper",
        py: 3,
        mt: "auto",
        borderTop: 1,
        borderColor: "divider",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          {/* Brand Section */}
          <Stack spacing={1} alignItems={isMobile ? "center" : "flex-start"}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <AutoStoriesIcon color="primary" />
              <Typography variant="h6" color="primary" sx={{ fontWeight: 700 }}>
                Thesis Genius
              </Typography>
            </Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ maxWidth: 300, textAlign: isMobile ? "center" : "left" }}
            >
              Empowering researchers with AI-driven literature review generation
            </Typography>
          </Stack>

          {/* Links Section */}
          <Stack
            direction={isMobile ? "column" : "row"}
            spacing={3}
            alignItems="center"
          >
            <Stack direction="row" spacing={1}>
              <IconButton
                disabled
                component={Link}
                href="https://linkedin.com/in/your-profile"
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
                size="small"
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                disabled
                component={Link}
                href="https://github.com/your-profile"
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
                size="small"
              >
                <GitHubIcon />
              </IconButton>
            </Stack>
          </Stack>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Copyright Section with Version and ID */}
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Stack spacing={0.5} alignItems={isMobile ? "center" : "flex-start"}>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ textAlign: "center" }}
            >
              © {new Date().getFullYear()} thesisgen.com. All rights reserved.
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "text.disabled",
                fontSize: "0.65rem",
                letterSpacing: "0.02em",
                opacity: 0.7,
              }}
            >
              v{packageInfo.version} • ID: {identifier.slice(-8)}
            </Typography>
          </Stack>

          <Stack
            direction={isMobile ? "column" : "row"}
            spacing={2}
            alignItems="center"
          >
            <Link
              color="text.secondary"
              underline="hover"
              sx={{ typography: "body2", cursor: "pointer" }}
            >
              Privacy Policy
            </Link>
            <Link
              onClick={() => navigate("/tnc")}
              color="text.secondary"
              underline="hover"
              sx={{ typography: "body2", cursor: "pointer" }}
            >
              Terms of Service
            </Link>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
